import { OpenEnrollmentCustomerConfigs } from '../../domain'

const getBooleanValue = (
  configuration: Record<string, unknown>,
  primaryKey: string,
  fallbackKey?: string
): boolean => {
  const primaryValue = configuration[primaryKey]
  if (typeof primaryValue === 'boolean') {
    return primaryValue
  }

  if (!fallbackKey) {
    return false
  }

  const fallbackValue = configuration[fallbackKey]
  return typeof fallbackValue === 'boolean' ? fallbackValue : false
}

export const parseOpenEnrollmentCustomerConfigs = (
  configuration: Record<string, unknown>
): OpenEnrollmentCustomerConfigs => ({
  isOpenEnrollmentEnabled: getBooleanValue(
    configuration,
    'isOpenEnrollmentEnabled',
    'isABP5OpenEnrollmentEnabled'
  ),
  isPeopleTabEnabled: getBooleanValue(
    configuration,
    'isOpenEnrollmentPeopleTabEnabled',
    'isPeopleTabEnabled'
  ),
})
